import React, {Component, useState} from 'react'
import ReactPlayer from "react-player";
import $ from 'jquery'
// import screenfull from 'screenfull'
// import { findDOMNode } from 'react-dom'
import SVGraphics from "../../assets/SVGraphics";
import Duration from "../../utils/Duration";
import '../../style/component/media/VideoPlayer.css'
import RangeInputVideo from "../input/RangeInputVideo";
import moment from "moment";

class VideoPlayerOtoscopeNew extends Component {

    constructor(props) {
        super(props);
        this.state = {
            title: 'Video Player',
            url: this.props.url,
            muted: false,
            playing: false,
            isFullscreen: false,
            played: 0,
            loaded: 0,
            duration: 0,
            currentPosition:0.0
        }
        this.player = null
    }

    load = url => {
        this.setState({
            url,
            played: 0,
            loaded: 0
        })
    }

    handlePlayPause = () => {
        this.setState({playing: !this.state.playing})

        if(!this.state.playing && navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1)
        {
            document.getElementById(`videoPlayer+${this.props.title}`).play()
        }
        else if(navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1){
            document.getElementById(`videoPlayer+${this.props.title}`).pause()
        }

    }

    handlePlay = () => {
        this.setState({playing: true})
    }

    handlePause = () => {
        this.setState({playing: false})
    }

    handleToggleMuted = () => {
        this.setState({muted: !this.state.muted})
    }

    ref = player => {
        this.player = player
    }

    handleSeekMouseDown = e => {
        this.setState({seeking: true})
    }


    handleSeekChange = e => {
        if(!(navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1)) {

            this.setState({played: parseFloat(e.target.value)})}
        else {

            let currentSeconds =  Math.floor(document.getElementById(`videoPlayer+${this.props.title}`).currentTime % 60);
            let played = 0+"."+currentSeconds ;


            this.setState({played})
        }
    }

    handleSeekMouseUp = e => {

        if(!(navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1)) {

            this.setState({seeking: false})
            this.player.seekTo(parseFloat(e.target.value))
        } else {
            let currentSeconds =  Math.floor(document.getElementById(`videoPlayer+${this.props.title}`).onmouseup % 60);
        }

    }

    handleProgress = state => {
        if (!this.state.seeking) {
            this.setState(state)
        }
        if (this.state.played >= 0.99999) {
            this.setState({played: 0})
            this.player.seekTo(0)
        }
    }

    handleDuration = (duration) => {
        this.setState({duration})
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.fileId !== nextProps.fileId)
            this.setState({title: nextProps.title, url: nextProps.url})
    }

    async componentDidMount() {
        this.setState({title: this.props.title, url: this.props.url})
        // await document.addEventListener('fullscreenchange', event => {this.handleFullScreenChange(event)}, false);
        // await document.addEventListener('mozfullscreenchange', event => {this.handleFullScreenChange(event)}, false);
        // await document.addEventListener('MSFullscreenChange', event => {this.handleFullScreenChange(event)}, false);
        // await document.addEventListener('webkitfullscreenchange', event => {this.handleFullScreenChange(event)}, false);
    }

    componentWillUnmount() {
        // document.removeEventListener('fullscreenchange',console.log('remove fullscreenchange'))
        // document.removeEventListener('mozfullscreenchange',console.log('remove mozfullscreenchange'))
        // document.removeEventListener('MSFullscreenChange',console.log('remove MSFullscreenChange'))
        // document.removeEventListener('webkitfullscreenchange',console.log('remove webkitfullscreenchange'))
    }

    handleClickFullscreen = async () => {
        if (this.props.openFullScreen) {
            this.setState({
                played: 0,
                playing: false
            })
            this.props.openFullScreen()
        }

    }

    handleFullScreenChange = async (event) => {
        this.setState({isFullscreen: !this.state.isFullscreen})
    }
    onEnded =  () => {
        this.setState({playing: false})
        this.setState({played: 0})
    }




    render() {
        const {title, url, playing, muted, isFullscreen, played, duration} = this.state
        let {className, videoFiltering, fullscreenClass,file} = this.props
        let time = moment(file?.createdAt).format('HH:mm');
        let date = moment(file?.createdAt).format('MMM DD YYYY');

        let isMouthThroat = title==="Ears"
        let contClass = 'ears-exam-video-player'
        let frameClass =  ' frame-otoscope-exam'
        let isSafari = navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1
        let video = document.getElementById(`videoPlayer+${title}`)
        let fullScreenStyle= isSafari?{
            bottom:"80px"
        }:null
        return (
            <div className={contClass}>
                <div className={frameClass}
                     // onClick={this.handleClickFullscreen}
                    >
                    <div className={'video-player-title'} style={{fontSize:isSafari?'0.85rem':'1rem'}}><span
                        style={{fontWeight: '600'}}>{`${file['type']} ${file['subType'] && file['subType'] !== 'None' ? file['subType']:'' } video`}</span> {time} | {date} </div>
                    {isSafari ? <video id={`videoPlayer+${title}`} onTimeUpdate={(e)=>this.handleSeekChange(e)} onEnded={()=>this.onEnded()}  style={{width: "100%", height: '92%',  padding:'5%'}}
                                       onSeeking={(e) => this.handleSeekChange(e)}
                                       onSeeked={(e) => this.handleSeekChange(e)}
                                       // onLoadedMetadata={this.props.onLoadedMetadata}
                                       // onPlaying={this.props.onPlaying}
                                       // onPause={this.props.onPause}
                                       // onMouseMove={this.props.onMouseMove}
                                       // onMouseOut={this.props.onMouseOut}
                                       // disablePictureInPicture
                                       playsInline
                                       preload="metadata"
                                       // muted
                                       webkit-playsinline
                                       controls
                                       disablePictureInPicture
                                       controlslist="nodownload noremoteplayback noplaybackrate nofullscreen "
                        >
                            {/*{url === this.props.url && <source src={url} type="video/mp4"/>}*/}
                            {/*{url !== this.props.url && <source src={url} type="video/mp4"/>}*/}
                            <source src={url+'#t=0.001'} type="video/mp4"/>
                        </video>
                        :

                        <video id={`videoPlayer+${title}`} onTimeUpdate={(e)=>this.handleSeekChange(e)} onEnded={()=>this.onEnded()}  style={{width: "100%",height:"92%", padding:'5%'}}
                               onSeeking={(e) => this.handleSeekChange(e)}
                               onSeeked={(e) => this.handleSeekChange(e)}
                               onLoadedMetadata={this.props.onLoadedMetadata}
                               onPlaying={this.props.onPlaying}
                               onPause={this.props.onPause}
                               onMouseMove={this.props.onMouseMove}
                               onMouseOut={this.props.onMouseOut}
                               webkit-playsinline
                               controls
                               playsInline
                               disablePictureInPicture
                               controlslist="nodownload noremoteplayback noplaybackrate nofullscreen "
                               src={url?url+'#t=0.001':this.props.url+'#t=0.001'}
                        />

                        //     <source src={url} type="video/mp4"/>
                        // </video>
                    }

                </div>
                        {/*{this.props.openFullScreen &&*/}
                        <SVGraphics svgname={'fullscreen-square-white'} onClick={this.handleClickFullscreen}
                                    style={fullScreenStyle}
                                    className={fullscreenClass}/>
                        {/*// }*/}

            </div>
        );
    }
}

export default VideoPlayerOtoscopeNew
